import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BlockBlobClient } from "@azure/storage-blob";
import { firstValueFrom } from "rxjs";

export const BlobClient = {
  create: (url: string) => new BlockBlobClient(url)
};

@Injectable()
export class BlobService {
  constructor(private http: HttpClient) {}

  async getBlobFromUrl(imageUrl: string): Promise<Blob> {
    return await firstValueFrom(this.http.get(imageUrl, { responseType: "blob", withCredentials: true }));
  }

  async getBase64ImageFromUrl(imageUrl: string): Promise<string> {
    const blob = await this.getBlobFromUrl(imageUrl);

    return await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.addEventListener(
        "load",
        function () {
          resolve(reader.result as string);
        },
        false
      );

      reader.onerror = (error) => {
        console.log(error);
        return reject(this);
      };
      reader.readAsDataURL(blob);
    });
  }
}
